import { render, staticRenderFns } from "./YKRecordings.vue?vue&type=template&id=45ad0ed4&"
import script from "./YKRecordings.vue?vue&type=script&lang=js&"
export * from "./YKRecordings.vue?vue&type=script&lang=js&"
import style0 from "./YKRecordings.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports